import { Box, styled } from "@mui/material";

export const BoxWrap = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '8px',
    paddingTop: 0,
    borderRadius: '8px',
    margin: theme.spacing(2),
    width: '100%'
}));
